import { render } from "./OnboardingSteps.vue?vue&type=template&id=aca5cd32"
import script from "./OnboardingSteps.vue?vue&type=script&lang=js"
export * from "./OnboardingSteps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__